import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/policy/page.tsx");
